export enum EmployeeWordFields {
    hr_login = "hr_login",
    hr_business_group_name = "hr_business_group_name",
    hr_last_name = "hr_last_name",
    hr_first_name = "hr_first_name",
    hr_middle_names = "hr_middle_names",
    hr_fio = "hr_fio",
    hr_familyio = "hr_familyio",
    hr_iofamily = "hr_iofamily",
    hr_birth_date = "hr_birth_date",
    hr_job_name = "hr_job_name",
    hr_inn = "hr_inn",
    hr_snils = "hr_snils",
    hr_citizenship = "hr_citizenship",
    hr_address = "hr_address",
    hr_address_alt = "hr_address_alt",
    hr_email = "hr_email",
    hr_phone = "hr_phone",
    id_doc_type = "id_doc_type",
    id_doc_series = "id_doc_series",
    id_doc_number = "id_doc_number",
    id_doc_date_from = "id_doc_date_from",
    id_doc_issued_by = "id_doc_issued_by",
    id_doc_date_to = "id_doc_date_to",
    id_doc_dep_code = "id_doc_dep_code",
    id_doc_full = "id_doc_full",
    hr_name_en = "hr_name_en",
    hr_fio_gen = "hr_fio_gen",
    hr_fio_dat = "hr_fio_dat",
    hr_fio_acc = "hr_fio_acc",
    hr_fio_inst = "hr_fio_inst",
    hr_fio_prepos = "hr_fio_prepos",
    hr_address_r = "hr_address_r",
    hr_address_c = "hr_address_c",
    hr_assignment_number = "hr_assignment_number",
    hr_contract_number = "hr_contract_number",
    hr_contract_date = "hr_contract_date",
    hr_employee_number = "hr_employee_number",
    hr_assg_job_name = "hr_assg_job_name",
    hr_assg_job_name_gen = "hr_assg_job_name_gen",
    hr_assg_job_name_dat = "hr_assg_job_name_dat",
    hr_assg_job_name_acc = "hr_assg_job_name_acc",
    hr_assg_job_name_inst = "hr_assg_job_name_inst",
    hr_assg_job_name_prepos = "hr_assg_job_name_prepos",
    hr_tax_unit_full_name = "hr_tax_unit_full_name",
    hr_tax_unit_short_name = "hr_tax_unit_short_name",
    hr_general_visa_familyio = "hr_general_visa_familyio",
    hr_general_visa_iofamily = "hr_general_visa_iofamily",
    hr_general_visa_fio = "hr_general_visa_fio",
    hr_general_visa_gen = "hr_general_visa_gen",
    hr_general_visa_dat = "hr_general_visa_dat",
    hr_general_visa_acc = "hr_general_visa_acc",
    hr_general_visa_inst = "hr_general_visa_inst",
    hr_general_visa_prepos = "hr_general_visa_prepos",
    hr_general_visa_job = "hr_general_visa_job",
    hr_general_visa_job_gen = "hr_general_visa_job_gen",
    hr_general_visa_job_dat = "hr_general_visa_job_dat",
    hr_general_visa_job_acc = "hr_general_visa_job_acc",
    hr_general_visa_job_inst = "hr_general_visa_job_inst",
    hr_general_visa_job_prepos = "hr_general_visa_job_prepos",
    hr_general_visa_snils = "hr_general_visa_snils",
    hr_dept_full_name = "hr_dept_full_name",
    hr_dept_short_name = "hr_dept_short_name",
    hr_dept_manag_name = "hr_dept_manag_name",

    hr_account_bank_name = "hr_account_bank_name",
    hr_account_bic = "hr_account_bic",
    hr_account_bank = "hr_account_bank",
    hr_account_pers = "hr_account_pers",
    hr_account_corr = "hr_account_corr",

    hr_sex = "hr_sex",
    hr_reg_city = "hr_reg_city",
    hr_loan_number = "hr_loan_number",
    hr_loan_purpose = "hr_loan_purpose",
    hr_loan_date = "hr_loan_date",
    hr_town_of_birth = "hr_town_of_birth",
    hr_region_of_birth = "hr_region_of_birth",
    hr_country_of_birth = "hr_country_of_birth",
    hr_marital_status_name = "hr_marital_status_name",
    hr_tk_status_name = "hr_tk_status_name",
    hr_reg_country = "hr_reg_country",
    hr_reg_region = "hr_reg_region",
    hr_reg_area = "hr_reg_area",
    hr_reg_town = "hr_reg_town",
    hr_reg_settlement = "hr_reg_settlement",
    hr_reg_street = "hr_reg_street",
    hr_reg_house = "hr_reg_house",
    hr_reg_building = "hr_reg_building",
    hr_reg_apartment = "hr_reg_apartment",
    hr_reg_postal_code = "hr_reg_postal_code",
    hr_reg_combination = "hr_reg_combination",
    hr_division = "hr_division",
    hr_it_num = "hr_it_num",
    hr_it_start_date = "hr_it_start_date",

    subpoena_receipt_date = "subpoena_receipt_date",
    subpoena_seria_num = "subpoena_seria_num",
    subpoena_appearence_date_time = "subpoena_appearence_date_time",
    subpoena_military_office = "subpoena_military_office",
    subpoena_military_office_address = "subpoena_military_office_address",
    subpoena_type = "subpoena_type",
    subpoena_reason = "subpoena_reason",

    hr_contact_full_name = "hr_contact_full_name",
    hr_contact_type = "hr_contact_type",
    hr_contact_date_of_birth = "hr_contact_date_of_birth",

    hr_qualification_name = "hr_qualification_name",
    hr_qualification_establishment = "hr_qualification_establishment",
    hr_qualification_type = "hr_qualification_type",
    hr_qualification_speciality = "hr_qualification_speciality",
    hr_qualification_doc_type = "hr_qualification_doc_type",
    hr_qualification_doc = "hr_qualification_doc",
    hr_qualification_awarded_date = "hr_qualification_awarded_date",
    hr_qualification_okso = "hr_qualification_okso",

    hr_military_doc_type = "hr_military_doc_type",
    hr_military_doc = "hr_military_doc",
    hr_military_doc_date = "hr_military_doc_date",
    hr_military_issued_by = "hr_military_issued_by",
    hr_military_worth_category = "hr_military_worth_category",
    hr_military_rank = "hr_military_rank",
    hr_military_reserve_category = "hr_military_reserve_category",
    hr_military_staff = "hr_military_staff",
    hr_military_speciality = "hr_military_speciality",
    hr_military_office = "hr_military_office"
}
